export const columns = [
  { id: "imp_nombre", label: "Nombre", align: "left", ordenable: true },
  { id: "imp_ip", label: "Dirección IP", align: "left", ordenable: true },
];

export const itemDefault = {
  imp_nombre: "",
  imp_ip: "",
};
